import React, { useState } from "react";
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { NewPageForm } from './NewPageForm'

export default function AddPageDialog() {
    const [open, setOpen] = useState(false)

    const handleClickOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }

    //handle form submit api here
    return (
        <div>
            <Button variant='contained' onClick={handleClickOpen}>
                Create Page
            </Button>

            <BootstrapDialog
                fullWidth
                maxWidth='lg'
                onClose={handleClose}
                aria-labelledby='customized-dialog-title'
                open={open}
            >
                <BootstrapDialogTitle onClose={handleClose}>
                    Add a new Page
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <NewPageForm handleClose={handleClose} />
                </DialogContent>
            </BootstrapDialog>
        </div>
    )
}
